module.exports={
  "_args": [
    [
      "yasgui-utils@^1.6.7",
      "/home/mistermboy/repositories/YASHE"
    ]
  ],
  "_from": "yasgui-utils@>=1.6.7 <2.0.0",
  "_id": "yasgui-utils@1.6.7",
  "_inCache": true,
  "_installable": true,
  "_location": "/yasgui-utils",
  "_nodeVersion": "7.10.0",
  "_npmOperationalInternal": {
    "host": "s3://npm-registry-packages",
    "tmp": "tmp/yasgui-utils-1.6.7.tgz_1495459781202_0.06725964159704745"
  },
  "_npmUser": {
    "email": "laurens.rietveld@gmail.com",
    "name": "laurens.rietveld"
  },
  "_npmVersion": "4.2.0",
  "_phantomChildren": {},
  "_requested": {
    "name": "yasgui-utils",
    "raw": "yasgui-utils@^1.6.7",
    "rawSpec": "^1.6.7",
    "scope": null,
    "spec": ">=1.6.7 <2.0.0",
    "type": "range"
  },
  "_requiredBy": [
    "/"
  ],
  "_resolved": "https://registry.npmjs.org/yasgui-utils/-/yasgui-utils-1.6.7.tgz",
  "_shasum": "2bcfc5a315688de3ae6057883d9ae342b205f267",
  "_shrinkwrap": null,
  "_spec": "yasgui-utils@^1.6.7",
  "_where": "/home/mistermboy/repositories/YASHE",
  "author": {
    "name": "Laurens Rietveld"
  },
  "bugs": {
    "url": "https://github.com/YASGUI/Utils/issues"
  },
  "dependencies": {
    "store": "^2.0.4"
  },
  "description": "Utils for YASGUI libs",
  "devDependencies": {},
  "directories": {},
  "dist": {
    "shasum": "2bcfc5a315688de3ae6057883d9ae342b205f267",
    "tarball": "https://registry.npmjs.org/yasgui-utils/-/yasgui-utils-1.6.7.tgz"
  },
  "gitHead": "6031b1cb732d390b29cd5376dceb9a9d665bbd11",
  "homepage": "https://github.com/YASGUI/Utils",
  "licenses": [
    {
      "type": "MIT",
      "url": "http://yasgui.github.io/license.txt"
    }
  ],
  "main": "src/main.js",
  "maintainers": [
    {
      "name": "laurens.rietveld",
      "email": "laurens.rietveld@gmail.com"
    }
  ],
  "name": "yasgui-utils",
  "optionalDependencies": {},
  "readme": "ERROR: No README data found!",
  "repository": {
    "type": "git",
    "url": "git://github.com/YASGUI/Utils.git"
  },
  "scripts": {},
  "version": "1.6.7"
}
